import React from "react";
import "./performanceManagement.css";
import sales_performance1 from "assets/salePerformance/sales_performance1.jpg";
import sales_performance2 from "assets/salePerformance/sales_performance2.jpg";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";

const PerformanceManagement = () => {
  const navigate = useNavigate();

  const handleGetDemo = (e) => {
    e.preventDefault();
    navigate("../request-a-demo");
  };

  return (
    <div className="performance-management-container">
      <div className="performance-top-heading">
        <h1>
          Monitor real estate sales performances accurately and effortlessly
          with CRM
        </h1>
        <p>
          Real Estate keeps track of individual and team sales performances and
          provides you with the analytics needed for corrective measures or
          enhancements. Furthermore, the metrics also help in sales forecasts
          and specific leads targeting, enabling an end-to-end Real Estate Lead
          Management System. These are just some of the many features offered by
          the Real Estate CRM Software for performance management. Read on to
          know more.
        </p>
        <button onClick={handleGetDemo} className="marketingAutomation-btn">
          GET A DEMO
        </button>
      </div>

      <div className="row">
        <div className="col-12 performance-management-col">
          <div className="col-3">
            <div className="right-side-heading">
              <h2>Performance Management</h2>
              <Link
                to="sales-performance"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Sales Performance Measurement
              </Link>
              <Link
                to="territory-management"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Territory Management
              </Link>
              <Link
                to="campaign-performance"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Campaign Performance
              </Link>
              <Link
                to="field-force-tracking"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Field Force Tracking with GPS
              </Link>
            </div>
          </div>
          <div className="col-9">
            <div
              className="performance-management-section"
              id="sales-performance"
            >
              <div className="performance-management-heading">
                <h2>Sales Performance Measurement</h2>
                <h1>Complete sales performance tracking with Real Estate</h1>
                <p>
                  With Real Estate’s sales performance measurement features, you
                  and your sales team members can see their performances
                  clearly. Which leaves no room for discrepancies. So, you know
                  whom to recognize and whom to encourage to improve the overall
                  performance of your team.
                </p>
              </div>
              <div className="performance-management-img">
                <img src={sales_performance1} alt="" />
              </div>
            </div>
            <div
              className="performance-management-section"
              id="territory-management"
            >
              <div className="performance-management-heading">
                <h2>Territory Management</h2>
                <p>
                  Real Estate allows you to manage & track your sales teams
                  across all your territories. Organizations that have
                  India-wide or even global operations, can easily set it up &
                  ensure access control & reporting for the entire sales
                  hierarchy
                </p>
              </div>
            </div>
            <div
              className="performance-management-section"
              id="campaign-performance"
            >
              <div className="performance-management-heading">
                <h2>Campaign Performance</h2>
                <h1>
                  In-depth campaign performance analysis with Real Estate CRM
                  Real Estate
                </h1>
                <p>
                  Real Estate helps you see the complete picture of your
                  marketing campaigns. With multiple metrics available to track,
                  it becomes easy for you to understand which marketing
                  campaigns are delivering best results and should be scaled,
                  and which ones should either be paused or stopped altogether.
                </p>
              </div>
              <div className="performance-management-img">
                <img src={sales_performance2} alt="" />
              </div>
            </div>
            <div
              className="performance-management-section"
              id="field-force-tracking"
            >
              <div className="performance-management-heading">
                <h2>Field Force Tracking with GPS</h2>
                <h1>
                  GPS-enabled field force performance tracking with Real Estate
                </h1>
                <p>
                  Dishonest practices by field professionals are rampant in many
                  organizations. Real Estate’s helps you curb them and keep your
                  employees self-aware with its GPS-enabled features that track
                  daily reporting, site visit completion, journey routes and
                  travel time among other data.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceManagement;
